const RoleAssumptionWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children }) => {
    return <>{children}</>;
};

export default RoleAssumptionWrapper;
